import { Box } from "src/ccl/layout";
import { styled } from "src/ccl/stitches";

export const HomepageContainer = styled(Box, {
  margin: "0 auto",
  width: "100%",
  maxWidth: "1720px",
  px: "$6",

  "@sm": {
    px: "$9",
  },

  "@xl": {
    px: "$16",
  },
});
